module.exports = __webpack_public_path__ + "static/media/logo_doc.a0d801d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_doc.svg
// module id = 42
// module chunks = 0